import TrackAssignmentModal from './TrackAssignmentModal';

export default TrackAssignmentModal;
